'use strict';

import {isArray} from  '../../lang';

export default {
  template: `<div></div>`,
  /**
   * @see http://vuejs.org/guide/components.html#Prop-Validation
   * @see https://api.jqueryui.com/slider/
   */
  props: {
    vModel: {
      twoWay: true,
      type: [Number,Array]
    },
    min: Number,
    max: Number,
    step: Number,
    steps: Array,
    range: {
      type: [String,Boolean],
      default: 'min'
    }
  },
  created() {
    this.modelWatcher = this.modelWatcher.bind(this);
    this.onChangeModel = this.onChangeModel.bind(this);
    this.onChangeView = this.onChangeView.bind(this);
  },
  attached() {
    let {min,max,step,range,steps} = this;
    if (isArray(steps)) {
      min = 0;
      max = steps.length - 1;
      step = 1
    }
    this.$element = jQuery(this.$el);
    this.$element.slider({
      slide: this.onChangeView,
      range,
      step,
      min,
      max
    });
    this.unwatchModel = this.$watch(this.modelWatcher, this.onChangeModel);
    this.setViewValue();
  },
  detached() {
    this.$element.slider('destroy');
    this.unwatchModel();
  },
  methods: {
    onChangeView(event, ui) {
      let {vModel,steps} = this;
      let key = isArray(vModel) ? 'values' : 'value';
      let value = ui[key];
      this.vModel = isArray(steps) ? steps[value] : value;
    },
    setViewValue() {
      let {vModel,steps} = this;
      let key = isArray(vModel) ? 'values' : 'value';
      let value = isArray(steps) ? steps.indexOf(vModel) : vModel;
      this.$element.slider(key, value);
    },
    modelWatcher() {
      return this.vModel;
    },
    onChangeModel(value) {
      this.setViewValue();
    }
  }
}




// WEBPACK FOOTER //
// ./src/js/components/slider/index.js